// Stage 7A D1 — pure text helpers for the Meta ad mockup.

// First non-blank string in an array, or '' when none.
export function firstNonEmpty(arr: string[] | undefined): string {
  return (arr ?? []).find((s) => typeof s === 'string' && s.trim().length > 0)?.trim() ?? '';
}

// Truncate to `max` characters, appending an ellipsis when clipped. Meta's Feed
// clamps primary text around 125 chars before a "See more" fold.
export function truncate(text: string, max: number): string {
  if (text.length <= max) return text;
  return `${text.slice(0, max).trimEnd()}…`;
}

// "+N more in rotation" suffix label for multi-input copy, or '' for ≤1 item.
export function rotationLabel(count: number, noun: string): string {
  const extra = count - 1;
  if (extra <= 0) return '';
  return `+${extra} more ${noun}${extra === 1 ? '' : 's'} in rotation`;
}
